import { flowRight, isEmpty } from 'lodash';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { push } from '../../services/router-utils';
import { fetchCurrentMember } from '../../actions/fetch-current-member';
import { fetchUserSettings } from '../../actions/fetch-user-settings';
import { setCommunitiesContext } from '../../actions/set-communities-context';
import { setDemoMode } from '../../actions/set-demo-mode';
import { setExperiments } from '../../actions/set-experiments';
import { setCurrentUser } from '../../actions/set-current-user';
import { setViewMode } from '../../actions/set-view-mode';
import { setUserAgent } from '../../actions/set-user-agent';
import fetchCategories from '../../actions/fetch-categories';
import { emitUserConnected } from '../../actions/user-socket';
import { emitForumOpened } from '../../actions/forum-socket';
import { fetchForumData } from '../../actions/fetch-forum-data';
import { fetchAppSettings } from '../../actions/fetch-app-settings';
import { enableNotificationCountChanges } from '../../actions/enable-notifications-count-change';
import { getCurrentUser } from '../../selectors/current-user-selectors';
import { getForumData } from '../../selectors/forum-data-selectors';
import { isEditor, isPreview, getViewMode } from '../../services/wix-sdk-utils';
import AppComponent from '../../components/app';
import withTranslate from '../../hoc/with-translate';

export class App extends Component {
  static fetchData = ({ store, pathname, search, user, demoMode, experiments, userAgent, communitiesContext }) => {
    const promises = [
      store.dispatch(setViewMode(getViewMode())),
      store.dispatch(setCommunitiesContext(communitiesContext)),
      store.dispatch(setDemoMode(Boolean(demoMode))),
      store.dispatch(setExperiments(experiments)),
      store.dispatch(setUserAgent(userAgent)),
      store.dispatch(fetchCategories()).then(() => {
        const { categories } = store.getState();
        if (categories.length === 1 && pathname === '/') {
          return store.dispatch(push(`/${categories[0].slug}${search}`));
        }
      }),
      store.dispatch(fetchAppSettings(search)),
      store.dispatch(fetchForumData()),
    ];
    if (user) {
      if (pathname === '/notifications') {
        promises.push(
          store.dispatch(enableNotificationCountChanges(false)),
        );
      }

      promises.push(
        store.dispatch(setCurrentUser(user)),
      );
      promises.push(
        store.dispatch(fetchUserSettings(user._id))
      );
    }
    return promises;
  };

  componentDidMount() {
    if (isEmpty(this.props.appSettings)) {
      this.props.fetchAppSettings();
    }
    if (isEmpty(this.props.forumData)) {
      this.props.fetchForumData();
    }
    if (!isEditor() && !isPreview()) {
      this.props.fetchCurrentMember();
    }
    if (!this.props.categories.length) {
      this.props.fetchCategories();
    }
    if (this.props.currentUser) {
      this.props.emitUserConnected(this.props.currentUser);
    }
    this.props.emitForumOpened();
  }

  componentWillReceiveProps(nextProps) {
    if (!this.props.categories.length && nextProps.categories.length === 1 && this.props.location.pathname === '/') {
      this.props.onCategoriesFetched(nextProps.categories);
    }

    if (!this.props.currentUser && nextProps.currentUser) {
      this.props.emitUserConnected(nextProps.currentUser);
    }
    if (nextProps.location.pathname === '/notifications') {
      this.props.enableNotificationCountChanges(false);
    } else {
      this.props.enableNotificationCountChanges(true);
    }
  }

  render() {
    const { t } = this.props;
    return this.props.categories.length ?
      <AppComponent {...this.props}/> :
      <div>
        {t('app.loading')}
      </div>;
  }
}

App.propTypes = {
  fetchCurrentMember: PropTypes.func.isRequired,
  appSettings: PropTypes.object.isRequired,
  forumData: PropTypes.object.isRequired,
  fetchForumData: PropTypes.func.isRequired,
  fetchAppSettings: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
  fetchCategories: PropTypes.func,
  emitUserConnected: PropTypes.func,
  emitForumOpened: PropTypes.func,
  enableNotificationCountChanges: PropTypes.func,
  location: PropTypes.object,
  currentUser: PropTypes.object,
  categories: PropTypes.array,
  onCategoriesFetched: PropTypes.func,
};

const mapStateToProps = (state, ownProps) => ({
  appSettings: state.appSettings,
  forumData: getForumData(state),
  categories: state.categories,
  location: ownProps.location,
  currentUser: getCurrentUser(state),
});

const mapDispatchToProps = dispatch =>
  bindActionCreators({
    emitUserConnected,
    emitForumOpened,
    fetchForumData,
    fetchCurrentMember,
    fetchCategories,
    onCategoriesFetched: categories => push(`/${categories[0].slug}`),
    enableNotificationCountChanges,
    fetchAppSettings,
  }, dispatch);

export default flowRight(
  connect(mapStateToProps, mapDispatchToProps),
  withTranslate,
)(App);



// WEBPACK FOOTER //
// ./app/containers/app/app.js